function About() {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <h1 className="text-3xl font-bold">About This Platform</h1>
        <p className="text-gray-700 mt-2">We verify health claims using AI.</p>
      </div>
    );
  }
  
  export default About;
  